import { findIndex, cloneDeep } from "lodash"
//import sendxAPI from '../../../xAPI'

const getTemplate = (type, index) => {

  let constantTemplate = {
    id: index + 1,
    type: "constant",
    duration: "00:00:30",
    temp: 24
  };

  let finalTemplate = {
    id: index + 1,
    type: "final",
    duration: "Infinity",
    temp: 24
  };

  let cyclingTemplate = {
    id: index + 1,
    type: "cycling",
    repeat: 35,
    subSteps: [
      {
        id: 1,
        duration: "00:00:30",
        temp: 24,
        cycleCount: 0
      },
      {
        id: 2,
        duration: "00:00:30",
        temp: 24,
        cycleCount: 0
      },
      {
        id: 3,
        duration: "00:00:30",
        temp: 24,
        cycleCount: 0
      }
    ]
  }

  if(type==="constant"){
    return constantTemplate
  } else if(type==="cycling") {
    return cyclingTemplate
  } else if(type==="final") {
    return finalTemplate
  }
}

const templateState = {
  id: -1,
  type: null,
  open: false,
  description: "",
  controlsVisible: false,
  numberOfSolutions: 0,
  solutions: [{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  }],
  currentSection: "SPLASH_SCREEN",
  currentDialog: "CHOOSE_TYPE",
  innerSection: "THERMOCYCLER_TABLE",
  displayDialog: false,
  editConnection: null,
  volume: 25,
  lid: 95,
  saved: true,
  totalTime: 0,
  durations: [],
  running: false,
  currentTime: 0,
  totalElapsedTime: 0,
  sequence: [],
  tempSequence: []
};

export function ThermocyclerReducer(state = { thermocyclers: [] }, action) {
  let currentThermocycler;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_THERMOCYCLER" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("thermocyclers")){
          currentThermocycler = state.protocolSection.scene.apparatus.thermocyclers[findIndex(state.protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_THERMOCYCLER':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("thermocyclers")){
            protocolSection.scene.apparatus.thermocyclers = [ ...protocolSection.scene.apparatus.thermocyclers, newObj ]
          } else {
            protocolSection.scene.apparatus.thermocyclers = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'THERMOCYCLER_OPEN':

            // xAPI statement
            // sendxAPI({
            //   // Type of statement
            //   verb: {
            //     description: (action.payload.open)?"opened":"closed",
            //     address: (action.payload.open)?"https://w3id.org/xapi/dod-isd/verbs/opened":"https://w3id.org/xapi/dod-isd/verbs/closed"
            //   },
            //   // Where the action occured
            //   context: currentThermocycler.type + " Thermocycler",
            //   // Result of the action
            //   result: {
            //     success: true,
            //     response: action.payload.open
            //   }
            // })

            currentThermocycler.open = action.payload.open
            protocolSection.scene.apparatus.thermocyclers[findIndex(state.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_CONTROLS_VISIBLE':

          // Hide the controls for all the other thermocyclers
          protocolSection.scene.apparatus.thermocyclers.forEach((thermocycler) => {
            thermocycler.controlsVisible = false;
          })
          // Make the current thermocyclers controls visible
          currentThermocycler.controlsVisible = action.payload.controlsVisible
          protocolSection.scene.apparatus.thermocyclers[findIndex(state.thermocyclers, { id: action.payload.id })] = currentThermocycler

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "ADD_TUBE_TO_THERMOCYCLER":
          //Payload = {id, type}

          let addSolutions = cloneDeep(currentThermocycler.solutions);
          let availableSlot = -1;

          for(var i = 0; i < currentThermocycler.solutions.length; i++){
            if(currentThermocycler.solutions[i].type == null){
              availableSlot = i;
              break;
            }
          }

          if(availableSlot !== -1){
            addSolutions[availableSlot].type = action.payload.type;
            addSolutions[availableSlot].id = action.payload.solutionId;
            currentThermocycler.numberOfSolutions++
          }

          currentThermocycler.solutions = addSolutions;
          protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "REMOVE_TUBE_FROM_THERMOCYCLER":
          //Payload = {id, type}
          let removeSolutions = cloneDeep(currentThermocycler.solutions);
          let index = findIndex(currentThermocycler.solutions, {id: action.payload.solutionId})

          if(index !== null && index !== -1 && removeSolutions.hasOwnProperty(index) && removeSolutions[index].type !== null){
            removeSolutions[index].type = null;
            removeSolutions[index].id = null;
            currentThermocycler.numberOfSolutions--
          }

          currentThermocycler.solutions = removeSolutions;
          protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "REMOVE_ALL_TUBES_FROM_THERMOCYCLER":
          //Payload = {id, type}
          currentThermocycler.solutions.forEach((solution)=>{
            solution.type = null;
            solution.id = null;
          })
          currentThermocycler.numberOfSolutions = 0

          protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'HIDE_ALL_CONTROLS':

            // Hide the controls for all the other thermocyclers
            if(protocolSection.scene.apparatus.hasOwnProperty("thermocyclers")){
              protocolSection.scene.apparatus.thermocyclers.forEach((thermocycler) => {
                thermocycler.controlsVisible = false;
              })
            }

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_SAVED':

          // Make the current thermocyclers controls visible
          currentThermocycler.saved = action.payload.saved
          protocolSection.scene.apparatus.thermocyclers[findIndex(state.thermocyclers, { id: action.payload.id })] = currentThermocycler

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'SET_THERMOCYCLER_VOLUME':
            currentThermocycler.volume = action.payload.volume;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_LID':
            currentThermocycler.lid = action.payload.lid;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_DURATIONS':
            currentThermocycler.durations = action.payload.durations;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_RUNNING':
            currentThermocycler.running = action.payload.running;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_CURRENT_TIME':
            currentThermocycler.currentTime = action.payload.currentTime;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_TOTAL_TIME':
            currentThermocycler.totalTime = action.payload.totalTime;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_ELAPSED_TIME':
            currentThermocycler.totalElapsedTime = action.payload.totalElapsedTime;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_INNER_SECTION':
            currentThermocycler.innerSection = action.payload.innerSection;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_EDIT_CONNECTION':
            currentThermocycler.editConnection = action.payload.editConnection;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_SECTION':

            currentThermocycler.currentSection = action.payload.section;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_DIALOG':
            currentThermocycler.currentDialog = action.payload.dialog;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_THERMOCYCLER_DIALOG_DISPLAY':
            currentThermocycler.displayDialog = action.payload.displayDialog;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'UPDATE_THERMOCYCLER_SEQUENCE':

            let updatedSequence = cloneDeep(currentThermocycler.sequence);
            updatedSequence[action.payload.index] = action.payload.item;

            currentThermocycler.sequence = updatedSequence;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'UPDATE_THERMOCYCLER_SEQUENCE_TEMP':

            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'UPDATE_THERMOCYCLER_SEQUENCE_TIME':

            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'UPDATE_THERMOCYCLER_SEQUENCE_REPEAT':

            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'ADD_THERMOCYCLER_SEQUENCE':

            let newSequence = cloneDeep(currentThermocycler.sequence);
            newSequence.splice(action.payload.index, 0, getTemplate(action.payload.type, action.payload.index))

            currentThermocycler.sequence = newSequence;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'REMOVE_THERMOCYCLER_SEQUENCE':

            let removeSequence = cloneDeep(currentThermocycler.sequence);
            removeSequence = removeSequence.filter(function(item, itemIndex) {
              return itemIndex !== action.payload.index
            })

            currentThermocycler.sequence = removeSequence;
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'ERASE_THERMOCYCLER_SEQUENCE':

            currentThermocycler.sequence = [];
            protocolSection.scene.apparatus.thermocyclers[findIndex(protocolSection.scene.apparatus.thermocyclers, { id: action.payload.id })] = currentThermocycler

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        // case "UNDO":
        //     //Payload = {lastState}
        //
        //     if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('thermocyclers')) {
        //
        //       protocolSection.scene.apparatus.thermocyclers = action.payload.lastState.scene.apparatus.thermocyclers
        //
        //       return { ...state, ...{
        //         protocolSection: protocolSection
        //       } }
        //
        //     } else {
        //       return state;
        //     }

        default:
            return state;
    }
}
